import React, { useEffect, useRef, useState } from "react";
import IndexNavbar from "components/Navbars/IndexNavbar";
import Footer from "components/Footers/Footer";
import FooterSmallNew from "components/Footers/FooterSmallNew";
import bghome from "assets/img/bghome.jpg";
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";
import aboutfish from "assets/img/aboutfish.jpeg";
import header3 from "assets/img/header3.png";
import quality from "assets/img/Quality-fish.webp";
import fishicon from "assets/img/fishicon.png";
import qualityimg1 from "assets/img/qualityimg1.png";
import qualityimg2 from "assets/img/qualityimg2.png";
import qualityimg from "assets/img/qualityimg1 (2).png";
import fishharvesting from "assets/img/fish-harvesting-01.webp";
import fishharvestingg from "assets/img/fish-harvesting-in-seashore.jpg";

const Quality = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleContent = () => {
    setIsOpen(!isOpen);
  };

  const [isOpen1, setIsOpen1] = useState(false);

  const toggleContent1 = () => {
    setIsOpen1(!isOpen1);
  };

  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();

  // Scroll down animation
  const sections = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    sections.current.forEach((section) => {
      if (section && section instanceof Element) {
        observer.observe(section);
      }
    });

    const handleScroll = debounce(() => {
      sections.current.forEach((section) => {
        if (section && section instanceof Element) {
          observer.observe(section);
        }
      });
    }, 100);

    window.addEventListener("scroll", handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  return (
    <section>
      <IndexNavbar />
      <section className="xl:pt-28 lg:pt-28 md:pt-17 pt-17"></section>
      <section
        ref={(el) => sections.current.push(el)}
        style={{
          position: "relative",
          backgroundImage: `url(${quality})`,
          // backgroundAttachment: "fixed",
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="animate-on-scroll xl:h-450 lg:h-300 md:h-300 justify-center text-white"
      >
        <div className="">
          <div className="container mx-auto overflow-hidden hometext xl:px-24 px-4">
            <div className="grid md:grid-cols-2 ">
              <div className="text-left bg-dark-blue xl:p-16 lg:p-16 md:p-12 p-12">
                <h1 className="banner-font text-white xl:pt-20 md:pt-8 font-extrabold xl:text-head1 lg:text-head1 headlineheight md:text-head1 text-head1 md:text-xl text-2xl">
                  {" "}
                  {t("qualitycontent1")}
                </h1>
                <p className="pt-2 xl:pt-2 text-white xl:mb-26 lg:mb-4 md:mb-6 banner-font xl:text-lg text-lg">
                  {" "}
                  {t("qualitycontent2")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="xl:block lg:block md:block sm:block block xl:mt-16 container mx-auto xl:px-24 px-4 mt-12">
        <div>
          <div>
            <h1 className="uppercase font-semibold banner-font text-dark xl:text-head1 lg:text-head1 md:text-head1 text-head1 text-center">
              {t("qualitycontent3")}
            </h1>
          </div>

          <div>
            <div
              className="flex justify-between items-center mt-4 p-5 rounded-lg"
              style={{
                backgroundColor: "#f5f5f5",
                backgroundSize: "cover",
              }}
            >
              <h1 className="text-2xl md:text-2xl lg:text-2xl xl:text-head1 text-left text-dark font-semibold">
                {t("qualitycontent4")}
              </h1>
              <p
                className="text-3xl text-dark font-semibold cursor-pointer"
                onClick={toggleContent}
              >
                {isOpen ? "-" : "+"}
              </p>
            </div>
            {isOpen && (
              <div
                className="pt-4 pl-4 pb-12"
                style={{
                  backgroundColor: "#f5f5f5",
                  backgroundSize: "cover",
                }}
              >
                {/* Your content goes here */}
                <div className="flex  items-start ">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent5")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent6")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent7")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent8")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent9")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent10")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent11")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent12")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent13")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent14")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent15")}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div>
            <div
              className="flex justify-between items-center mt-2 p-5 rounded-lg"
              style={{
                backgroundColor: "#f5f5f5",
                backgroundSize: "cover",
              }}
            >
              <h1 className="text-2xl md:text-2xl lg:text-2xl xl:text-head1 text-left text-dark font-semibold">
                {t("qualitycontent16")}
              </h1>
              <p
                className="text-3xl text-dark font-semibold cursor-pointer"
                onClick={toggleContent1}
              >
                {isOpen1 ? "-" : "+"}
              </p>
            </div>
            {isOpen1 && (
              <div
                className="pt-4 pb-12 pl-4"
                style={{
                  backgroundColor: "#f5f5f5",
                  backgroundSize: "cover",
                }}
              >
                {/* Your content goes here */}
                <div className="flex  items-start ">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent17")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent18")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent19")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent20")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent21")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent22")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent23")}
                    </p>
                  </div>
                </div>

                <div className="flex  items-start mt-4">
                  <div className=" ">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark mt-1">
                      <p className="text-white">✓</p>
                    </div>
                  </div>
                  <div className=" ml-4">
                    <p className="text-lg font-semibold text-grayBlue">
                      {" "}
                      {t("qualitycontent24")}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <section
        ref={(el) => sections.current.push(el)}
        style={{
          // backgroundColor: "#f5f5f5",
          backgroundColor: "rgb(0 149 207 / 7%)",
          backgroundSize: "cover",
        }}
        className="animate-on-scroll xl:mt-16 lg:mt-16 md:mt-16 mt-12"
      >
        <div className="container mx-auto overflow-hidden px-4 xl:py-16 xl:px-12 lg:px-12 lg:py-8 py-6">
          <div className="grid md:grid-cols-2 grid-cols-1 xl:pt-8 md:pt-8 pt-4 xl:px-12 items-center banner-font">
            <div className="z-2 xl:ml-0 xl:mr-4">
              <div className="bg-dark border-l xl:p-12 md:p-8 p-8 rounded-lg">
                <div className="text-left">
                  <h1 className="xl:text-2xl lg:text-2xl md:text-2xl text-2xl text-white banner-font">
                    {" "}
                    {t("qualitycontent50")}
                  </h1>
                  <p className="xl:pt-2 md:pt-4 pt-2 xl:text-para text-justify text-base text-white banner-font">
                    {" "}
                    {t("qualitycontent51")}
                  </p>
                </div>
              </div>
            </div>
            <div className="xl:-ml-32 lg:-ml-32 md:-ml-20 md:mt-0 mt-4">
              <img
                src={fishharvestingg}
                className="xl:h-maxnew rounded-lg lg:h-maxnew md:h-320 xl:w-12/12 lg:w-12/12"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="xl:block lg:block md:block sm:block block container mx-auto xl:px-24 px-4 xl:mt-16 lg:mt-16 md:mt-16 mt-12 banner-font">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-2">
          <div className="bg-dark-blue rounded-lg">
            <div className=" h-full w-full max-w-xs p-6">
              <div className="flex justify-center">
                <img class="w-12" src={qualityimg} alt="" />
              </div>
              <h1 className="text-xl font-semibold text-white pt-2 text-center">
                {t("qualitycontent52")}
              </h1>
              <p className="text-base pt-2 text-center text-white">
                {t("qualitycontent53")}
              </p>
            </div>
          </div>

          <div className="bg-dark-blue rounded-lg ">
            <div className="  h-full w-full max-w-xs p-6">
              <div className="flex justify-center">
                <img class="w-12" src={fishicon} alt="" />
              </div>
              <h1 className="text-xl font-semibold text-white pt-2 text-center">
                {t("qualitycontent54")}
              </h1>
              <p className="text-base pt-2 text-center text-white">
                {t("qualitycontent55")}
              </p>
            </div>
          </div>

          <div className="bg-dark-blue rounded-lg">
            <div className=" h-full w-full max-w-xs p-6">
              <div className="flex justify-center">
                <img class="w-12" src={qualityimg2} alt="" />
              </div>
              <h1 className="text-xl font-semibold text-white pt-2 text-center">
                {t("qualitycontent56")}
              </h1>
              <p className="text-base pt-2 text-center text-white">
                {t("qualitycontent57")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="xl:block lg:block md:block sm:block block container mx-auto xl:px-24 px-4 banner-font xl:mt-16 lg:mt-16 md:mt-16 mt-12 xl:pb-16 lg:pb-16 md:pb-16 ">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2">
          <div>
            <div
              className="xl:p-8 rounded-lg h-full w-full max-w-xs lg:p-8 md:p-6 p-6"
              style={{
                backgroundColor: "#f5f5f5",
                backgroundSize: "cover",
              }}
            >
              <h1 className="text-2xl md:text-2xl lg:text-2xl xl:text-head1 text-left text-dark font-bold">
                {t("qualitycontent58")}
              </h1>
              <div className="flex xl:mt-6 items-start lg:mt-6 md:mt-6 mt-4">
                <div className=" ">
                  <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark">
                    <p className="text-white">✔</p>
                  </div>
                </div>
                <div className="xl:ml-8 ml-4">
                  <p className="xl:text-base text-base text-justify">
                    {" "}
                    {t("qualitycontent59")}
                  </p>
                </div>
              </div>

              <div className="flex xl:mt-4 items-start lg:mt-4 md:mt-4 mt-4">
                <div className=" ">
                  <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark">
                    <p className="text-white">✔</p>
                  </div>
                </div>
                <div className="xl:ml-8 ml-4">
                  <p className="xl:text-base text-base text-justify">
                    {" "}
                    {t("qualitycontent60")}
                  </p>
                </div>
              </div>

              <div className="flex xl:mt-4 items-start lg:mt-4 md:mt-4 mt-4">
                <div className=" ">
                  <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark">
                    <p className="text-white">✔</p>
                  </div>
                </div>
                <div className="xl:ml-8 ml-4">
                  <p className="xl:text-base text-base text-justify">
                    {" "}
                    {t("qualitycontent61")}
                  </p>
                </div>
              </div>

              <a href="/products">
                <button className="xl:mt-16 lg:mt-20 md:mt-28 mt-8  text-sm banner-font text-blue-dark border-dark-blue   px-6 py-2 ">
                  {" "}
                  {t("qualitycontent62")}
                </button>
              </a>
            </div>
          </div>

          <div>
            <div
              className="xl:p-8 rounded-lg h-full w-full max-w-xs lg:p-8 md:p-6 p-6"
              style={{
                backgroundColor: "rgb(0 149 207 / 7%)",
                backgroundSize: "cover",
              }}
            >
              <h1 className="text-2xl md:text-2xl lg:text-2xl xl:text-head1 text-left text-dark font-bold">
                {t("qualitycontent63")}
              </h1>
              <div className="flex xl:mt-6 items-start lg:mt-6 md:mt-6 mt-4">
                <div className=" ">
                  <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark">
                    <p className="text-white">✔</p>
                  </div>
                </div>
                <div className="xl:ml-8 ml-4">
                  <p className="xl:text-base text-base text-justify">
                    {" "}
                    {t("qualitycontent64")}
                  </p>
                </div>
              </div>
              -
              <div className="flex xl:mt-4 items-start lg:mt-4 md:mt-4 mt-4">
                <div className=" ">
                  <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark">
                    <p className="text-white">✔</p>
                  </div>
                </div>
                <div className="xl:ml-8 ml-4">
                  <p className="xl:text-base text-base text-justify">
                    {" "}
                    {t("qualitycontent65")}
                  </p>
                </div>
              </div>
              <div className="flex xl:mt-4 items-start lg:mt-4 md:mt-4 mt-4">
                <div className=" ">
                  <div className="flex items-center justify-center w-6 h-6 rounded-full bg-dark">
                    <p className="text-white">✔</p>
                  </div>
                </div>
                <div className="xl:ml-8 ml-4">
                  <p className="xl:text-base text-base text-justify">
                    {" "}
                    {t("qualitycontent66")}
                  </p>
                </div>
              </div>
              <a href="/products">
                <button className="xl:mt-10 mt-8  text-sm banner-font text-blue-dark border-dark-blue  px-6 py-2 ">
                  {" "}
                  {t("qualitycontent62")}
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FooterSmallNew />
    </section>
  );
};

export default Quality;
